import React, { useEffect, useState } from "react";

const MESSAGES = [
  "Reviewing the data...",
  "Spotting patterns...",
  "Cross-checking the numbers...",
  "Drafting takeaways...",
  "Almost done...",
];

// Shared loading state for the "Analyze with Claude/AI" buttons (Landing
// Page Performance, Payment Issues, Socials Timeline, Usage Data) - a
// rotating status message plus a fixed time estimate, since none of those
// callers can report real progress on the underlying Anthropic API call.
export default function AnalyzingIndicator({ color = "#667eea" }) {
  const [messageIndex, setMessageIndex] = useState(0);

  useEffect(() => {
    setMessageIndex(0);
    const interval = setInterval(() => {
      setMessageIndex((i) => (i + 1) % MESSAGES.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "10px", margin: "10px 0" }}>
      <span
        style={{
          display: "inline-block", width: "16px", height: "16px", flexShrink: 0,
          border: `2px solid ${color}33`, borderTopColor: color, borderRadius: "50%",
          animation: "admin-analyzing-spin 0.8s linear infinite",
        }}
      />
      <span style={{ fontSize: "13px", color: "#555" }}>
        {MESSAGES[messageIndex]}
        <br />
        <span style={{ fontSize: "11px", color: "#999" }}>Usually takes 30 seconds to a minute.</span>
      </span>
    </div>
  );
}
